import _ from 'lodash';
import { useMemo } from 'react';

/**
 * Create the chartTrend array for a set of "top-N" data. It expects a mappingOptions object which has
 * a nameMapping to find the label for each series represented in the table data, plus a set of colors
 * it can use for each series. If the number of series is larger than the number of colors supplied, it
 * will "wrap" them.
 *
 * @param {Object} baseTrend A chartTrend template used to override defaultTrend
 * @param {[Object]} tableData An array of data, one row per series
 * @param {Object} seriesOptions The nameMapping and colors required for building the chartTrend array
 * @returns {[Object]} chartTrend definitions
 */
export function useTableSeries(baseTrend, tableData, seriesOptions) {
    const { nameMapping, colors } = seriesOptions;

    return useMemo(() => {
        if (!nameMapping || !colors?.length || !tableData) return null;

        return _(tableData)
            .map((item, dataIndex) => {
                const seriesConfig = {
                    label: _.get(item, nameMapping),
                    color: colors[dataIndex % colors.length],
                    dataIndex,
                };
                return _.merge({}, baseTrend, seriesConfig);
            })
            .value();
    }, [baseTrend, colors, nameMapping, tableData]);
}
